module.exports = __webpack_public_path__ + "media/images/icon_pin_all_sp-356fb2e0986a53e0bf98f7a9792bdc1e.svg";